import TextArea from 'antd/es/input/TextArea';
import Block from '../Base/Block';
import DrawerDialog, { DrawerDialogRef } from '../Base/DrawerDialog';
import ScrollView from '../Base/ScrollView';
import View from '../Base/View';
import Loading from '../Loading';
import './index.scss'
import Text from '../Base/Text';
import Image from '../Base/Image';
import { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react';
import util from '../../utils/util';
import { toast } from '../../utils/toast';
import rm from '../../utils/rm';
import orderManager from '../../manager/order';
import './index.scss'

export interface RefundRequestDialogRef {
    open: (orderInfo: any) => void
}

const RefundRequestDialog = forwardRef((prop, ref) => {

    const [orderInfo, setOrderInfo] = useState<any>();
    const [reasonList, setReasonList] = useState<any[]>([])
    const [selected, setSelected] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(true);
    const [loadFailed, setLoadFailed] = useState<boolean>(false);
    const [reasonText, setReasonText] = useState<string>("");
    const [requestedList, setRequestedList] = useState<any[]>([]);
    const [requestThisTime, setRequestThisTime] = useState<boolean>(false);
    const [result, setResult] = useState<any>({});
    const [isSubmtting, setSubmiting] = useState<boolean>(false);
    const drawerRef = useRef<DrawerDialogRef>();

    const _requestJsutNow = useCallback(() => {
        var requested =
            requestedList.indexOf(orderInfo.Id) !== -1
        setRequestThisTime(requested)
        return requested
    }, [requestedList, orderInfo]);

    const _confirmClick = () => {
        if (
            !loadFailed &&
            !loading &&
            orderInfo.CancelRequestStatusId == 0 &&
            !_requestJsutNow()
        ) {
            // 提交申请
            var info = {
                orderId: orderInfo.Id,
                comment:
                    reasonList[selected] +
                    (util.isEmpty(reasonText)
                        ? ''
                        : ',' + reasonText),
            }
            // console.log(info)
            if (isSubmtting) {
                toast.warning('正在提交，请稍等')
                return
            }
            rm.showLoading({ title: '提交中' })
            setSubmiting(true);
            orderManager.orderPaidCancelRequest(
                info,
                function (success: boolean, res: any, tips: string) {
                    rm.hideLoading()
                    if (success) {
                        var idList = requestedList
                        idList.push(orderInfo.Id)
                        setRequestedList(idList);
                        drawerRef.current?.close()
                    }
                    toast.info(tips)
                    setSubmiting(false);
                }
            )
        } else {
            drawerRef.current?.close()
        }
    }

    useEffect(() => {
        if (orderInfo) {
            if (
                orderInfo.CancelRequestStatusId == 0 &&
                !_requestJsutNow()
            ) {
                // 未提交过申请，获取退款理由
                setLoading(true)
                orderManager.getPaidOrderCancelReasons(
                    function (success: boolean, res: any, tips: string) {
                        console.log('退款理由:', res)
                        if (success) {
                            var list = res.data.Content
                            list.push('其他')
                            setReasonList(list)
                            setLoading(false)
                            setLoadFailed(false)
                            console.log(list)
                        } else {
                            setLoading(false)
                            setLoadFailed(true)
                            toast.error(tips)
                        }
                    }
                )
            } else {
                setLoading(true)
                // 已申请退款，查询处理结果
                orderManager.getPaidOrderCancelDetail(
                    orderInfo.Id,
                    function (success: boolean, res1: any, tips: string) {
                        console.log('申请结果:', res1)
                        if (success) {
                            // 获取结果成功
                            var result = res1.data.Content
                            result.AddTimeArray = util.getTimeArry(result.AddTime)
                            result.DealTimeArray = util.getTimeArry(result.DealTime)

                            setLoading(false)
                            setLoadFailed(false)
                            setResult(result)
                        } else {
                            setLoading(false)
                            setLoadFailed(true)
                            toast.error(tips)
                        }
                    }
                )
            }
        }
    }, [orderInfo])

    useImperativeHandle(ref, () => ({
        open: (orderInfo: any) => {
         
            setOrderInfo(orderInfo);
            drawerRef.current?.open();
        }
    }))

    return <DrawerDialog
        direction={0}
        ref={drawerRef}
        onVisibleChange={(visible)=>{
            if(!visible){
                setOrderInfo(undefined);
                setRequestThisTime(false)
                setResult(undefined);
                setReasonList([]);
            }
        }}
    >
        <Block>
            <View
                className="pannel-content refundDialog"
            // onTouchMove={this._consumeTouchmove}
            >
                <View className="pannel-title">
                    {orderInfo?.CancelRequestStatusId != 0 || requestThisTime
                        ? '申请退款进度查询'
                        : '申请退款'}
                </View>
                {/*  加载中  */}
                {loading ? (
                    <Block>
                        <Loading
                            style={{
                                width: 25,
                                height: 25,
                                marginTop: 50,
                                opacity: 0.5
                            }}

                        ></Loading>
                        <View
                            style={{
                                width: '100%',
                                height: '2.5rem',
                            }}
                        ></View>
                    </Block>
                ) : loadFailed ? (
                    <View
                        style={{
                            width: '100%',
                            height: '5rem',
                            lineHeight: '5rem',
                            fontSize: '0.75rem',
                            color: '#bbbbbb',
                            textAlign: 'center',
                        }}
                    >
                        加载失败，请稍后重试
                    </View>
                ) : orderInfo?.CancelRequestStatusId == 0 && !requestThisTime ? (
                    <ScrollView
                        className="reason-list"
                        scrollY={true}
                        enableBackToTop={true}
                        scrollWithAnimation={true}
                    >
                        <Block>
                            {reasonList?.map((item, index) => {
                                return (
                                    <Block>
                                        <View
                                            className="reason-list-item"
                                            data-index={index}
                                            onClick={() => {
                                                setSelected(index)
                                            }}
                                        >
                                            <Text>{item}</Text>
                                            <Image
                                                className="reason-select-icon"
                                                src={
                                                    require('../../images/cart-' +
                                                        (selected == index ? 'select' : 'unselect') +
                                                        '.png')
                                                }
                                            ></Image>
                                        </View>
                                    </Block>
                                )
                            })}
                        </Block>
                        <View className="input-container">
                            <TextArea
                                className="error-content"
                                onChange={(e) => {
                                    setReasonText(e.target.value)
                                }}
                                value={reasonText}
                                // adjustPosition="true"
                                placeholder="请详细描述申请售后的具体原因"
                                name="errorContent"
                            ></TextArea>
                        </View>
                    </ScrollView>
                ) : (
                    <>

                        {result && <View className="refund-result">
                            <View className="refund-result-title">申请原因</View>
                            <View className="refund-result-content">
                                <Text>
                                    {result.CustomerComment}
                                </Text>
                                <br />
                                <Text>
                                    {result.AddTimeArray[0] +
                                        '-' +
                                        result.AddTimeArray[1] +
                                        '-' +
                                        result.AddTimeArray[2] +
                                        ' ' +
                                        result.AddTimeArray[3] +
                                        ':' +
                                        result.AddTimeArray[4]}
                                </Text>
                            </View>
                            <View className="refund-result-title">
                                {result.CancelRequestStatus}
                            </View>
                            <View className="refund-result-content">
                                <Text>
                                    {(result.StaffComment != null
                                        ? result.StaffComment
                                        : '等待处理')}
                                </Text>
                                <br />
                                <Text>
                                    {(result.DealTime != null
                                        ? result.DealTimeArray[0] +
                                        '-' +
                                        result.DealTimeArray[1] +
                                        '-' +
                                        result.DealTimeArray[2] +
                                        ' ' +
                                        result.DealTimeArray[3] +
                                        ':' +
                                        result.DealTimeArray[4]
                                        : '')}
                                </Text>
                            </View>
                        </View>}
                    </>

                )}
                {/*  未申请  */}
                {/*  已申请  */}
                <View className="confirm-btn" onClick={_confirmClick}>
                    {loading
                        ? '关闭'
                        : orderInfo?.CancelRequestStatusId != 0 || requestThisTime
                            ? '收起'
                            : '提交申请'}
                </View>
            </View>
        </Block>
    </DrawerDialog>
})

export default RefundRequestDialog;